import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';




  export default class GeneralParamsWarehouses extends Component{ 

    constructor(props){
      super(props);

      this.state={
          warehouses:[],
          modalTitle:"",
          warehousename:"",
          warehouseid:0,
          covertime:"",
          isactive: true,
          country: {
            countryname: "",
            countryid:0
            },

          WarehouseIdFilter:"",
          WarehouseNameFilter:"",
          warehousesWithoutFilter:[],
          countryNames: [],        // Holds the list of country names
          warehouseNames: [],
          warehouseExists: false,
          uniqueWarehouseIdsForecasts:[],
          uniqueWarehouseIdsCostGrid:[],
          uniqueWarehouseIdsReturns:[],
          uniqueWarehouseIdsInventories:[],
          uniqueWarehouseIdsPurchases:[],
      }
  }

  FilterFn(){
    var WarehouseIdFilter=this.state.WarehouseIdFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;

    var filteredData=this.state.warehousesWithoutFilter.filter(
        function(el){
            return el.warehouseid.toString().toLowerCase().includes(
                WarehouseIdFilter.toString().trim().toLowerCase()
            )&&
            el.warehousename.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({warehouses:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.warehousesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({warehouses:sortedData});

}

changeWarehouseIdFilter = (e)=>{
  this.state.WarehouseIdFilter=e.target.value;
  this.FilterFn();
}
changeWarehouseNameFilter = (e)=>{
  this.state.WarehouseNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/warehouses/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({warehouses:data,warehousesWithoutFilter:data});
  });
}


fetchCountryNames() {
  axiosService.get('/countrynames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames = filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}


fetchWarehouseNames() {
  axiosService.get('/warehouses/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const warehouseNames = data.map(item => item.warehousename);
      this.setState({ warehouseNames: warehouseNames });
    })
    .catch(error => {
      console.error("Error fetching warehouse names:", error);
    });
}

checkWarehouseExists = (event) => {
  const enteredWarehouse = event.target.value.toLowerCase(); // Convert to lowercase
  const { warehouseNames } = this.state;
  const warehouseExists = warehouseNames.some((warehouse) => warehouse.toLowerCase() === enteredWarehouse);
  this.setState({ warehouseExists });
};


handleInput = (event) => {
  const inputValue = event.target.value;
  const regex = /^\d*$/;
  if (!regex.test(inputValue)) {
    event.target.value = inputValue.replace(/[^0-9]/g, '');
  }
};


fetchWarehouseIdsForecasts() {
  axiosService.get('/forecasts/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueWarehouseIdsForecasts = [...new Set(data.map((item) => item.warehouseid))];
      this.setState({ uniqueWarehouseIdsForecasts: uniqueWarehouseIdsForecasts });
    })
    .catch((error) => {
      console.error('Error fetching Forecasts data:', error);
    });
}

fetchWarehouseIdsCostGrid() {
  axiosService.get('/costgridcreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueWarehouseIdsCostGrid = [...new Set(data.map((item) => item.warehouseid))];
      this.setState({ uniqueWarehouseIdsCostGrid: uniqueWarehouseIdsCostGrid });
    })
    .catch((error) => {
      console.error('Error fetching CostGrid data:', error);
    });
}

fetchWarehouseIdsReturns() {
  axiosService.get('/returnscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueWarehouseIdsReturns = [...new Set(data.map((item) => item.warehouseid))];
      this.setState({ uniqueWarehouseIdsReturns: uniqueWarehouseIdsReturns });
    })
    .catch((error) => {
      console.error('Error fetching Returns data:', error);
    });
}

fetchWarehouseIdsInventories() {
  axiosService.get('/inventoriescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueWarehouseIdsInventories = [...new Set(data.map((item) => item.warehouseid))];
      this.setState({ uniqueWarehouseIdsInventories: uniqueWarehouseIdsInventories });
    })
    .catch((error) => {
      console.error('Error fetching Inventories data:', error);
    });
}

fetchWarehouseIdsPurchases() {
  axiosService.get('/purchasescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueWarehouseIdsPurchases = [...new Set(data.map((item) => item.warehouseid))];
      this.setState({ uniqueWarehouseIdsPurchases: uniqueWarehouseIdsPurchases });
    })
    .catch((error) => {
      console.error('Error fetching Purchases data:', error);
    });
}




componentDidMount(){
  this.refreshList();
  this.fetchCountryNames();
  this.fetchWarehouseNames();
  this.fetchWarehouseIdsForecasts();
  this.fetchWarehouseIdsCostGrid();
  this.fetchWarehouseIdsReturns();
  this.fetchWarehouseIdsInventories();
  this.fetchWarehouseIdsPurchases();
}

changeWarehouseName =(e)=>{
  this.setState({warehousename:e.target.value});
}

changeCoverTime =(e)=>{
  this.setState({covertime:e.target.value});
}

changeIsActive = (event) => {
  const isChecked = event.target.checked;
  this.setState({ isactive: isChecked });
};


changeCountryName =(e)=>{
  this.setState({warehousename:e.target.value});
}

resetSelect = () => {
  setTimeout(() => {
    this.setState({ selectedCountry: this.state.countryname });
  }, 0);
};


addClick(){
  this.setState({
      modalTitle:"Add Warehouse",
      warehouseid:0,
      warehousename: "",
      covertime:"",
      isactive: true,
      countryname:"",
      warehouseExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit Warehouse",
      warehouseid:dep.warehouseid,
      warehousename:dep.warehousename,
      covertime:dep.covertime,
      isactive:dep.isactive,
      countryname:dep.country.countryname,
      inititialWarehousename:dep.warehousename,
      initialCovertime:dep.covertime,
      initialIsactive:dep.isactive,
      initialCountryname:dep.country.countryname,
      warehouseExists: false,

  });
}

createClick() {
  const { warehousename,covertime, isactive, countryname, warehouseNames } = this.state;

  if (!warehousename) {
    alert('Warehouse Name is required');
    return;
  }

  
  if (warehouseNames.some(name => name.toLowerCase() === warehousename.toLowerCase())) {
    alert('Warehouse already exists. Please provide a unique Warehouse Name.');
    return;
  }

  if (!covertime) {
    alert('Cover Time is required');
    return;
  }

  if (!countryname) {
    alert('Country is required');
    return;
  }


  axiosService.post('/warehousescreate/', {
    warehousename: warehousename,
    covertime: covertime,
    isactive : isactive,
    countryname : countryname
  })
    .then(result => {
      alert('Warehouse created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });

    
}


updateClick(id){

  const { warehousename, covertime, isactive, countryname, inititialWarehousename, initialCovertime, initialIsactive, initialCountryname, warehouseNames } = this.state;

  // Check if any changes are detected
  if (
   warehousename === inititialWarehousename &&
   covertime === initialCovertime &&
   isactive === initialIsactive &&
   countryname === initialCountryname
 ) {
   alert('No changes detected');
   return;
 }

 if (
  warehouseNames.some((existingWarehouse) =>existingWarehouse.toLowerCase() === warehousename.toLowerCase() && warehousename !== inititialWarehousename
  )
) {
  this.setState({ warehousename: inititialWarehousename });
  return;
}

if (!warehousename) {
  alert('Warehouse Name is required');
  return;
}

if (!covertime) {
  alert('Cover Time is required');
  return;
}

if (!countryname) {
  alert('Country is required');
  return;
}


  axiosService.patch('/warehouses/'+id+'/',{
      warehouseid:this.state.warehouseid,
      warehousename:this.state.warehousename,
      covertime:this.state.covertime,
      isactive:this.state.isactive,
      countryname:this.state.countryname

  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (this.state.uniqueWarehouseIdsForecasts.includes(id)) {
    alert('Cannot delete this Warehouse as it is in the Forecasts Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueWarehouseIdsCostGrid.includes(id)) {
    alert('Cannot delete this Warehouse as it is in the CostGrid Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueWarehouseIdsReturns.includes(id)) {
    alert('Cannot delete this Warehouse as it is in the Returns Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueWarehouseIdsInventories.includes(id)) {
    alert('Cannot delete this Warehouse as it is in the Inventories Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueWarehouseIdsPurchases.includes(id)) {
    alert('Cannot delete this Warehouse as it is in the Purchases Table !');
    return; // Exit the function without making the delete request
  }

  if (window.confirm('Are you sure?')) {
    axiosService.delete('/warehouses/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      warehouses,
      modalTitle,
      warehouseid,
      warehousename,
      covertime,
      isactive,
      countryname,
      warehouseExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Warehouse
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseIdFilter}
      placeholder="Filter"/>

      </div>
      WarehouseId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>

      </div>
      WarehouseName
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      CoverTime(months)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      IsActive
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Country
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {warehouses.map(dep=>
      <tr key={dep.warehouseid} className="row-hover">
          <td className="table-text">{dep.warehouseid}</td>
          <td className="table-text">{dep.warehousename}</td>
          <td className="table-text">{dep.covertime}</td>
          <td className="table-text">{dep.isactive.toString()}</td>
          <td className="table-text">{dep.country.countryname}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.warehouseid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <form>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Warehouse Name</span>
          <input
            type="text"
            className={`form-control ${warehouseExists ? "is-invalid" : ""}`}
            value={warehousename}
            onChange={this.changeWarehouseName}
            onBlur={this.checkWarehouseExists} 
            style={{ fontSize: "12px" }} 
          />
          {warehouseExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Warehouse already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >CoverTime(months)</span>
          <input  type="number" className="form-control" value={covertime} onChange={this.changeCoverTime}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }} 
           />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Isactive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
        

        {warehouseid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {warehouseid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(warehouseid)}>
            Update
          </button>
         
        ) : null}
         </form>
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

